export default circleRating

/** @ngInject */
function circleRating() {
    return ({
        restrict: 'E',
        template: require('./view.jade')(),
        scope: {
            grade: '=',
        },
        link(scope) {
            return scope.$watch('grade', () => {
                const rest = 3 - Number(scope.grade)
                if (scope.grade !== 0) {
                    scope.gradeRange = __range__(1, scope.grade, true)
                } else {
                    scope.gradeRange = []
                }
                if (rest !== 0) {
                    scope.restRange = __range__(1, rest, true)
                } else {
                    scope.restRange = []
                }
            })
        },
    })
}

function __range__(left, right, inclusive) {
    const range = []
    const ascending = left < right
    const end = !inclusive ? right : ascending ? right + 1 : right - 1
    for (let i = left; ascending ? i < end : i > end; ascending ? i += 1 : i -= 1) {
        range.push(i)
    }
    return range
}



// WEBPACK FOOTER //
// ./src/directives/circle-rating/directive.js